/**
 * カートの削除（×）を押したときに、ブラウザの確認ダイアログを出します。
 * キャンセルするとその場で止まり、削除は実行されません。
 */

document.addEventListener(
  'click',
  (event) => {
    const button = event.target.closest('cart-remove-button');
    if (!button) return;

    const host = button.closest('[data-remove-confirm]');
    const message = host && host.dataset.removeConfirm;
    if (!message) return;

    if (!window.confirm(message)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true
);
